import { Backdrop, Box, Typography } from '@mui/material';

const PulseLoader = () => {
  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
      open={true}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        gap={2}
      >
        <Box
          component="img"
          src="https://inboxlogy-cdn.s3.us-east-1.amazonaws.com/assets/images/png/profile.png"
          alt="Loading..."
          sx={{
            width: { xs: '60px', sm: '70px', md: '80px' },
            height: 'auto',
            animation: 'pulse 1.5s ease-in-out infinite',
            '@keyframes pulse': {
              '0%': {
                transform: 'scale(0.9)',
                opacity: 1,
              },
              '50%': {
                transform: 'scale(1.15)',
                opacity: 0.8,
              },
              '100%': {
                transform: 'scale(0.9)',
                opacity: 1,
              },
            },
          }}
        />
        <Typography variant="body1" sx={{ color: '#fff', fontWeight: 500 }}>
          Loading...
        </Typography>
      </Box>
    </Backdrop>
  );
};

export default PulseLoader;
